import Vue from 'vue'
// 防止重复点击
const preventReClick = Vue.directive('preventReClick', {
  inserted: function(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        clearTimeout(timeout)
        const timeout = setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

export {
  preventReClick
}
